import React from 'react';

function Example({ term, packs }) {
    const names = (Array.isArray(term.packIds) ? term.packIds : []).map(id => (packs || []).find(p => p.id === id)?.label).filter(Boolean);
    return <div className="space-y-3">
        {names.length > 0 && <p className="font-display text-book-muted text-xs">{names.join(' · ')}</p>}
        <p className="font-serif text-book-text text-sm leading-relaxed">{term.definition}</p>
        {term.example && <p className="font-serif italic text-book-muted text-sm leading-relaxed pl-3 border-l-2 border-book-accent/30">{term.example}</p>}
        {term.tip && <div className="pt-3 border-t border-book-line"><p className="font-display text-book-accent text-xs font-semibold mb-1">Exam tip</p><p className="font-serif text-book-muted text-sm leading-relaxed">{term.tip}</p></div>}
    </div>;
}
export default function TerminologyCard({ group, packs, preview = false }) {
    if (!group?.variants?.length) return null;
    return <article className="rounded-[var(--radius-card)] border border-book-line bg-book-page p-5 break-words">
        <div className="flex items-start justify-between gap-3 flex-wrap mb-4">
            <h3 className="font-display text-book-text text-xl font-semibold">{group.name}</h3>
            <span className="text-book-muted font-display text-xs">{group.categories.join(' · ')}</span>
        </div>
        <Example term={group.variants[0]} packs={packs} />
        {!preview && group.variants.length > 1 && <details className="mt-4 border-t border-book-line pt-3">
            <summary className="cursor-pointer font-display text-book-accent text-sm">{group.variants.length - 1} more {group.variants.length === 2 ? 'example or explanation' : 'examples and explanations'}</summary>
            <div className="space-y-5 mt-4">{group.variants.slice(1).map((term, i) => <div key={i} className="border-t border-book-line pt-4"><Example term={term} packs={packs} /></div>)}</div>
        </details>}
    </article>;
}
